import { useTheme } from 'styled-components';

import { ResponseGraphics as Graphics } from '../../../../models/common-payments';
import { AmountsBarGraph } from '../amount-graphic';
import { BanksPieChart } from '../banks-pie-chart';
import {
	HeaderContainer,
	SectionContainer,
	SectionContent,
	SectionDate,
	SectionHeader,
	SectionTitle,
} from './styles';

interface PaymentLinkHeaderProps {
	data?: Graphics;
	loading?: boolean;
}

const PaymentLinkHeader = ({ data, loading }: PaymentLinkHeaderProps) => {
	const { colors } = useTheme();
	const COLORS = [colors.extra.crab, '#9D95FA', '#B6B0FB', '#CECAFD', '#F3F2FE', '#a648f9'];

	return (
		<HeaderContainer>
			<SectionContainer>
				<SectionHeader>
					<SectionTitle>Monto recaudado</SectionTitle>
					<SectionDate>Últimas 24 horas</SectionDate>
				</SectionHeader>

				<SectionContent>
					<AmountsBarGraph data={data?.amounts} barColor="#9D95FA" tooltipColor="#e8e7eb" />
				</SectionContent>
			</SectionContainer>

			<SectionContainer>
				<SectionHeader>
					<SectionTitle>Cobros exitosos por banco</SectionTitle>
					<SectionDate>Últimas 24 horas</SectionDate>
				</SectionHeader>

				<SectionContent>
					<BanksPieChart data={data} colors={COLORS} tooltipColor="#e8e7eb" loading={loading} />
				</SectionContent>
			</SectionContainer>
		</HeaderContainer>
	);
};

export { PaymentLinkHeader };
